var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLoyaltyTier1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 60 60"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BFC9FF",
  d: "M52.65 0H7.35L0 7.35v45.3L7.35 60h45.3L60 52.65V7.35z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M34.013 48.083h-6.2V19.15l-6.82 6.304V17.91l6.82-5.993h6.2z"
})));
export default SvgLoyaltyTier1;